import {Alert, Button, Divider, Grid, IconButton, Menu, MenuItem, styled} from "@mui/material";
import {useAsync2, useAsyncAction, useAuthenticated} from "nate-react-api-helpers";
import {api} from "../../api/API";
import {Loader} from "../Loader";
import {grey} from "@mui/material/colors";
import {DateString} from "../../api/Projects";
import moment from "moment";
import MarkEmailRead from "@mui/icons-material/MarkEmailRead";
import Delete from "@mui/icons-material/Delete";
import {useSyncedRef} from "../SyncedRef";
import {UserNotif} from "../../api/UserNotifications";
import {useState} from "react";
import {ViewTask} from "../../pages/tasks/ViewTask";

export function TaskMenu(props: {
    onClose(): void;
    anchorEl: any;
}) {
    const list = useAsync2((input) => api.userNotifications.list(input), {}, []);

    const reloadRef = useSyncedRef(list.reload);
    const auth = useAuthenticated()
    const authRef = useSyncedRef(auth);

    const update = useAsyncAction(async (input) => {
        await api.userNotifications.upsert(input);
        reloadRef.current();
        authRef.current.forcePing()
    }, []);

    const bulk = useAsyncAction(async (input) => {
        await api.userNotifications.upsertBulk(input);
        reloadRef.current();
        authRef.current.forcePing()
    }, []);

    const [showTask, setShowTask] = useState<number>();

    return (
        <Menu open anchorEl={props.anchorEl} onClose={props.onClose} style={{minHeight: 200}}>
            <div style={{paddingLeft: 8, paddingRight: 6, paddingBottom: 8}}>
                <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                    <Grid item xs>
                        <div style={{fontSize: "0.8rem", color: grey["700"]}}>
                            Notifications
                        </div>
                    </Grid>
                    <Grid item>
                        <Button onClick={() => {
                            bulk.callback({
                                list: list.asList.map(l => Object.assign({}, l, {
                                    read: true,
                                })),
                            })
                        }} size="small" variant="outlined">Mark all as Read</Button>
                    </Grid>
                </Grid>
            </div>
            <Divider/>
            <Loader<UserNotif[]> {...list}>
                {data => <>{
                    data.map(l => (
                        <MenuItem key={l.id} onClick={() => {
                            if(l.task2) {
                                setShowTask(l.task2);
                            }

                            update.callback(Object.assign({}, l, {
                                read: true,
                            }));
                        }}>
                            <div style={{width: 24}}>
                                <Dot read={l.read}/>
                            </div>
                            <div style={{flex: 1}}>
                                <div style={{
                                    fontSize: "0.8rem",
                                }}>{l.overline}</div>
                                <div>{l.content}</div>
                                <div style={{fontSize: "0.7rem"}}>{createdAt(l.createdAt)}</div>
                            </div>
                            <div>
                                <IconButton size="small" onClick={(e) => {
                                    e.stopPropagation();
                                    update.callback(Object.assign({}, l, {
                                        archived: true,
                                    }));
                                }}>
                                    <Delete/>
                                </IconButton>
                            </div>
                            {!l.read && <div>
                                <IconButton size="small" onClick={e => {
                                    e.stopPropagation();

                                    update.callback(Object.assign({}, l, {
                                        read: true,
                                    }));
                                }}>
                                    <MarkEmailRead/>
                                </IconButton>
                            </div>}
                        </MenuItem>
                    ))}
                    {data.length === 0 && <div>
                        <Alert color="info">
                            Nothing here
                        </Alert>
                    </div>}
                </>
                }
            </Loader>

            {showTask && <ViewTask id={showTask} onClose={() => setShowTask(undefined)}/>}

        </Menu>
    )
}

export function createdAt(input: DateString) {
    const tm = moment(input);
    const sinceMs = Date.now() - tm.valueOf();
    if(sinceMs < 30 * 60 * 1000) {
        return "Created a few minutes ago";
    }

    if(tm.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
        return "Created today";
    }

    return "Created " + tm.diff(moment(), "days") + " days ago"
}

const Dot = styled("div")<{read: boolean}>(props => ({
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: props.read ? grey["400"] : props.theme.palette.primary.main,
}))